import {listCards, listWorkflowsInfo, listPhasesInfo, createCard, deleteCard} from 'backend/workflow';

export function createAutomationCard(name, userId, phase){
	
	let cardsList = "";
	listCards(	"e1b37e30-9fa3-4e91-98d2-3bc22b555dee"	)
		.then( (cardsList)=> {
		console.log('cardsList x', name);
	    // console.log(cardsList);
		let phaseId = "";
		listPhasesInfo("e1b37e30-9fa3-4e91-98d2-3bc22b555dee").then((phases)=>{
			console.log('phases', phases);
			for(let j = 0; j < phases.items.length; j++ ){
				//console.log('phases items', phases.items[j])
				if(name.includes(phases.items[j].name)){
					console.log( "phase match", phases.items[j])
					phaseId = phases.items[j].id;
				}
			}

			let cardExists = false;
			for(let i = 0; i < cardsList.length; i++){
				if(cardsList.items[i].contactId ==  userId){
					cardExists = true;
					console.log('card exists');
					// console.log(cardsList.items[i]);
					deleteCard(cardsList.items[i].id);
				}
			}
			if(!cardExists){
					name = name + " taken";
					createCard("e1b37e30-9fa3-4e91-98d2-3bc22b555dee", phaseId,  userId, 1, 'name' )
					.then( (cardId) => {
						console.log("cardId = "+ cardId);
						deleteCard(cardId);
					});

				}
			})
	})
		

	  	
}